import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';
import Swiper, { FreeMode } from 'swiper';

import { PageCardPropsType } from 'Type/CMS.type';

import PageRelatedList from './PageRelatedList.component';

import './PageRelatedList.style';

/** @namespace PeggysagePwa/Component/PageRelatedList/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isMobile: state.ConfigReducer.device.isMobile
});

/** @namespace PeggysagePwa/Component/PageRelatedList/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
    // ...
});

/** @namespace PeggysagePwa/Component/PageRelatedList/Container */
export class PageRelatedListContainer extends PureComponent {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        title: PropTypes.string,
        pages: PropTypes.arrayOf(PageCardPropsType),
        linkLabel: PropTypes.string,
        isHorizontallyDisplayedOnMobile: PropTypes.bool
    };

    static defaultProps = {
        title: '',
        pages: [],
        linkLabel: '',
        isHorizontallyDisplayedOnMobile: false
    };

    listRef = createRef();

    componentDidMount() {
        if (this.listRef.current) {
            // Add slider classes
            // FIXME: utiliser du JSX plutôt que d'accéder au DOM directement
            this.listRef.current.classList.add('swiper');
            this.listRef.current.querySelector('.PageRelatedList-Items').classList.add('swiper-wrapper');
            Array.from(this.listRef.current.querySelectorAll('.PageRelatedList-Item')).forEach((el) => {
                el.classList.add('swiper-slide');
            });

            const sliderOptions = {
                modules: [FreeMode],
                loop: false,
                slidesPerView: 1.1,
                spaceBetween: 20,
                centerInsufficientSlides: true,
                freeMode: {
                    enabled: false,
                    sticky: true,
                    momentumBounce: false,
                    momentumRatio: 0.5
                },
                breakpoints: {
                    810: {
                        slidesPerView: 3
                    }
                }
            };

            // Initialize slider
            // eslint-disable-next-line
            new Swiper('.PageRelatedList-Content.swiper', sliderOptions);
        }
    }

    containerProps() {
        const {
            isMobile,
            title,
            pages,
            linkLabel,
            isHorizontallyDisplayedOnMobile
        } = this.props;

        return {
            isMobile,
            title,
            pages,
            linkLabel,
            isHorizontallyDisplayedOnMobile,
            listRef: this.listRef
        };
    }

    render() {
        return (
            <PageRelatedList
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageRelatedListContainer);
